export const communityLandingPageIsEnabled =
  process.env.REACT_APP_ENABLE_COMMUNITY_LANDING_PAGE === "true";
export const isDevMode = process.env.NODE_ENV === "development";

const config = {
  communityLandingPageIsEnabled,
  isDevMode,
};

export default config;
